/**
 * The long runs of a store: the API's `kind`. The comparison only reads the
 * store; a publication sets Ninja's numbers on it, after confirming the
 * comparison and every night.
 */
export const RUN_KIND = {
  CATALOG: 'catalog',
  STOCK_PREVIEW: 'activation_preview',
  PUBLISH: 'publish',
};

/** Where a run stands. */
export const RUN_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  DONE: 'done',
  FAILED: 'failed',
};

/**
 * The linked products by state: the listing's `status` filter, and the keys
 * the server counts them under (`listings`).
 */
export const LISTING_FILTER = {
  ALL: 'all',
  OK: 'ok',
  ERROR: 'error',
  DISABLED: 'disabled',
};

/** What confirming the comparison does to one product in the store: the row's `state`. */
export const ALIGNMENT_STATE = {
  UP: 'up',
  DOWN: 'down',
  SAME: 'same',
  NOT_STOCKED: 'not_stocked',
  VIRTUAL_KIT: 'virtual_kit',
  PAUSED: 'paused',
};

/** The chips over a comparison's rows: all, or one state. */
export const ALIGNMENT_FILTER = {
  ALL: 'all',
  ...ALIGNMENT_STATE,
};

/** A sale of the store that Ninja never got as an order, by where it stands: the `status` filter. */
export const STORE_SALE_FILTER = {
  ALL: 'all',
  DISCOUNTED: 'discounted',
  SETTLED: 'settled',
  RETURNED: 'returned',
};

/** The pages that watch a store. What they watch stops when they go. */
export const STOCK_SYNC_WATCHER = {
  PRODUCTS: 'products',
  INVENTORY: 'inventory',
  LISTINGS: 'listings',
  ALIGNMENT: 'alignment',
  STORE_SALES: 'store_sales',
};

/** How often a run in progress, and a product on its way to the store, are read again. */
export const RUN_POLL_MS = 3000;
export const PENDING_POLL_MS = 3000;

/** A run still "running" after this lost its worker: the backend frees its lock at the hour. */
export const RUN_WATCH_MAX_MS = 60 * 60 * 1000;

/** The server keeps a push pending five minutes at most. */
export const PENDING_WATCH_MAX_MS = 6 * 60 * 1000;

/** The listing of stores is capped at a hundred a page; a few pages are walked. */
export const CHANNELS_PAGE_SIZE = 100;
export const MAX_CHANNEL_PAGES = 5;

export const STOCK_SYNC_NOTICE = 'stock-sync-notice';

/** The linked products of a store, a page of the inventory. */
export const SHOPIFY_LISTINGS_PATH = '/warehouse/inventory/shopify';

/** Where a comparison is reviewed and confirmed. */
export const SHOPIFY_ALIGNMENT_PATH = '/warehouse/inventory/shopify/sync';

/** The store's own sales that Ninja took out of its stock. */
export const SHOPIFY_STORE_SALES_PATH = '/warehouse/inventory/shopify/sales';
